import { cn } from "@/lib/utils";
import { Card } from "@/components/ui/card";
import { getStatusColor, TableStatus } from "@/lib/floorPlanUtils";

const legendItems: { status: TableStatus; label: string }[] = [
  { status: 'free', label: 'Libre' },
  { status: 'reserved', label: 'Réservé' },
  { status: 'arrived', label: 'Arrivé' },
  { status: 'late', label: 'En retard' },
  { status: 'no-show', label: 'No-show' },
  { status: 'inactive', label: 'Inactive' },
];

export const FloorPlanLegend = () => {
  return (
    <Card className="p-4">
      <div className="flex flex-wrap items-center gap-4">
        <span className="text-sm font-medium text-muted-foreground">Légende :</span>
        {legendItems.map(({ status, label }) => (
          <div key={status} className="flex items-center gap-2">
            <div className={cn(
              "w-4 h-4 rounded border-2",
              getStatusColor(status)
            )} />
            <span className="text-sm">{label}</span>
          </div>
        ))}
        {/* Combined table indicator */}
        <div className="flex items-center gap-2">
          <div className="w-4 h-4 flex items-center justify-center">
            <div className="w-3 h-3 rounded-full bg-purple-500/30 border border-purple-500" />
          </div>
          <span className="text-sm">Combinée</span>
        </div>
      </div>
    </Card>
  );
};
